import styled from 'styled-components';

export const PatientAlertHistoryContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  padding-left: 32px;
  padding-right: 32px;
  padding-bottom: 32px;
`;
